<template>
  <div class="slideshow">
    <div class="slideshow-header float-left" v-for="item in finalArray" :key="item.id" :style="{'padding-top': aspectRatio, 'background-image': isBG ? 'url('+item.img+')' : 'none'}" :class="{'maximum-width': (item.id === currentSelection), 'solid-color': (item.id === currentSelection)}">
    </div>
    <div class="container">
      <p v-for="item in finalArray[currentSelection].description" :key="item.id">
        {{item.text}}
        <br />
      </p>
    </div>
    <p class="slideshow-arrow" style="left:0px; right:92%; float:left" v-if="currentSelection > 0" v-on:click="changeSlide(-1)">
      &lt;
    </p>
    <p class="slideshow-arrow" style="left:92%; right:0px; float:right" v-if="currentSelection < finalArray.length -1" v-on:click="changeSlide(1)">
      &gt;
    </p>
  </div>
</template>
<script>
export default {
  name: 'slideshow',
  props: {
    images: Array,
    aspectRatio: String,
    isBG: Boolean
  },
  data () {
    return {
      currentSelection: 0
    }
  },
  methods: {
    changeSlide (modifier) {
      this.currentSelection += modifier
    }
  },
  computed: {
    finalArray () {
      return this.images.map(function (item) {
        var miniObject = {
          id: item.id,
          img: '',
          description: item.description
        }
        if (item.img !== undefined) {
          miniObject.img = require('@/assets/slideshow/' + item.img)
        }
        return miniObject
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Slideshow.vue